import { useCallback, useState } from 'react';
import { MouseSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove } from '@dnd-kit/sortable';

export const useDndLabels = ({ values, move, findItemById }) => {
  const [items, setItems] = useState([...(values || [])]);
  const [activeId, setActiveId] = useState(null);

  const sensors = useSensors(
    useSensor(MouseSensor, {
      activationConstraint: {
        delay: 250,
      },
    }),
    useSensor(TouchSensor)
  );

  const handleDragStart = useCallback((event) => {
    setActiveId(event.active.id);
  }, []);

  const handleDragEnd = useCallback((event) => {
    const { active, over } = event;
    if (!active.id || !over?.id) return;
    if (active.id !== over?.id) {
      setItems((items) => {
        const oldItem = findItemById(items, active.id);
        const newItem = findItemById(items, over.id);
        const oldIndex = items.indexOf(oldItem);
        const newIndex = items.indexOf(newItem);
        // move(oldIndex, newIndex);
        return arrayMove(items, oldIndex, newIndex);
      });
    }
    setActiveId(null);
  }, [setItems, move, findItemById]);

  const handleDragOver = useCallback(() => {

  }, [])

  const handleDragCancel = useCallback(() => {
    setActiveId(null);
  }, []);

  return { items, setItems, activeId, sensors, handleDragStart, handleDragEnd, handleDragCancel, handleDragOver };
};
